module.exports = __webpack_public_path__ + "static/media/guilt@2x.52aec80f.png";